import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@mch-group/uikit-components';
/**
 * HOW TO USE
 * 1. Import the context/provider, if you're gonna use in the same place context/provider:
 * import Confirm, { ConfirmContext } from '@providers/Confirm'
 *
 * 2. How to call one of its functions, example, showNotification
 * <button onClick={() => showNotification({
        labels: {
          message: 'Are you sure you want to permanently delete the collection %nameofcollection%',
          ok: 'Delete',
          cancel: 'Cancel'
        },
        onOK: () => {},
        onCancel: () => {}
      })}
      >Click me!
      </button>

  * 3. If you don't want to wrap several components just to use this functionality:
  wrap your component like this:
  const RmHeadlineWithContext = () => <Confirm><YourComponent /></Confirm>
  and then export RmHeadlineWithContext:
  export default RmHeadlineWithContext
 */

var ConfirmContext = createContext();

var ConfirmProvider = function ConfirmProvider(props) {
  var children = props.children;
  var defaultParams = {
    labels: {
      message: 'Are you sure?',
      ok: 'Ok',
      cancel: 'Cancel'
    }
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      labels = _useState4[0],
      setLabels = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      actions = _useState6[0],
      setActions = _useState6[1];

  var showConfirm = function showConfirm(params) {
    // Merges the default params with those coming from the request
    var newParams = _objectSpread({}, defaultParams, params); // Sets the new message


    setLabels(newParams.labels);
    setActions(newParams.actions); // Makes it visible

    setVisible(true);
  };

  return /*#__PURE__*/React.createElement(ConfirmContext.Provider, {
    value: {
      showConfirm: showConfirm,
      setVisible: setVisible,
      visible: visible
    }
  }, visible && /*#__PURE__*/React.createElement(Modal, {
    show: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    title: labels.title,
    subline: labels.subText,
    onHide: function onHide() {
      return setVisible(false);
    }
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("p", null, labels.message)), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      actions.onCancel();
    },
    variant: "secondary"
  }, labels.cancel), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      actions.onOK();
    }
  }, labels.ok))), children);
};

ConfirmProvider.propTypes = {
  children: PropTypes.node
};
export default ConfirmProvider;
export { ConfirmContext };